import {RemotePostElectronicBill} from 'data/usecases/private/my-payments-flow/remote-electronic-bill';
import {PostElectronicBill} from 'domain/usecases/private/my-payments-flow/post-set-electronic-bill';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostElectronicBill = (): PostElectronicBill =>
	new RemotePostElectronicBill(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.electronicBill),
		makeAuthorizeHttpClientDecorator(),
	);
